import { Link } from "react-router-dom";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta(
    "页面未找到 - 吴梦梦影视官网",
    "你访问的页面不存在或已被移动，返回首页继续浏览吴梦梦的影视作品与最新资讯。",
  );

  return (
    <div className="container-content py-20 md:py-28">
      <div className="max-w-lg mx-auto text-center">
        <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-background-100 text-foreground-400">
          <i className="ri-film-line text-3xl leading-none" />
        </span>
        <p className="mt-5 font-label text-4xl font-extrabold text-primary-600">404</p>
        <h1 className="mt-2 text-xl md:text-2xl font-bold">这个镜头被剪掉了</h1>
        <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
          你访问的页面不存在，或者链接已经变更。回到首页，继续浏览吴梦梦的影视作品与最新资讯。
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/works"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-background-300 text-sm font-medium text-foreground-800 hover:border-primary-400 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            浏览作品
          </Link>
        </div>
      </div>
    </div>
  );
}